var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 37,
    viewBox: "0 0 34 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5006 1.34959C13.7202 1.61648 13.8548 1.9431 13.8868 2.28725C13.9189 2.6314 13.8471 2.97727 13.6806 3.28017C12.3797 5.66858 11.7003 8.34579 11.705 11.0655C11.705 20.1131 19.0808 27.4394 28.1712 27.4394C29.357 27.4394 30.5113 27.3157 31.6206 27.0794C31.9606 27.0058 32.3148 27.0339 32.639 27.1604C32.9631 27.2868 33.2428 27.506 33.4431 27.7904C33.6546 28.0862 33.7624 28.4436 33.7498 28.807C33.7372 29.1703 33.6049 29.5194 33.3734 29.7998C31.6086 31.9676 29.3823 33.7143 26.8567 34.9124C24.3312 36.1106 21.5701 36.73 18.7748 36.7256C8.40185 36.7256 0 28.3687 0 18.0723C0 10.323 4.7567 3.67618 11.5295 0.859066C11.8669 0.716482 12.2414 0.687217 12.5968 0.775668C12.9522 0.864118 13.2694 1.06551 13.5006 1.34959Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.660bb1dd7f571d9d808f8725b3f65ae2.svg";
export { ForwardRef as ReactComponent };